module.exports = {
	"classes": [
		"b2c",
		"header-dark"
	],
	"title": "Better, Easier Identity Management for B2C Companies",
	"metas": {
		"description": "Drive new revenue by securely acquiring more customers, and driving more conversions and upsells using identity data and analytics."
	},
	"opengraph": {
		"og:title": "Better, Easier Identity Management for B2C Companies",
		"og:description": "Drive new revenue by securely acquiring more customers, and driving more conversions and upsells using identity data and analytics.",
		"og:url": "https://auth0.com/b2c-customer-identity-management",
		"og:image": "https://cdn.auth0.com/website/assets/pages/b2c/img/b2c-new-twitter-card-cb4d5ef1f4.png",
		"og:image:secure_url": "https://cdn.auth0.com/website/assets/pages/b2c/img/b2c-new-twitter-card-cb4d5ef1f4.png"
	},
	"twittercard": {
		"twitter:title": "Better, Easier Identity Management for B2C Companies",
		"twitter:description": "Drive new revenue by securely acquiring more customers, and driving more conversions and upsells using identity data and analytics.",
		"twitter:image": [
			{
				"src": "https://cdn.auth0.com/website/assets/pages/b2c/img/b2c-new-twitter-card-cb4d5ef1f4.png"
			}
		]
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/pages/b2c/metadata.json
// module id = 1369
// module chunks = 0